<template>
  <div class="p-16 border-sm border-border-tertiary rounded-md">
    <AppToggleSwitch
      v-model="toggleIsChecked"
      input-id="toggle-binding-period-new-customer"
      :label="`${
        discountForBindingPerdiodExists
          ? 'Bind abonnemanget 12 månader för kampanj'
          : 'Bind abonnemanget 12 månader'
      }`"
      class="mb-16"
    />
    <div
      v-if="discountForBindingPerdiodExists"
      class="flex flex-row flex-wrap items-center"
    >
      <p class="me-8">
        <span class="text-text-success">Kampanj</span> för abonnemanget!
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { general_mapDiscountsToLabels } from '~/utils/general/label';

const familyStore = useFamilyStore();

const MAX_AMOUNT_OF_LABELS = 2;
const toggleIsChecked: Ref<boolean> = ref(
  familyStore.inputs.bindingPeriodRadioValue === '12' ? true : false,
);

const discountForBindingPerdiodExists = computed(() => {
  const discounts = familyStore.parentPlanBindingPeriodDiscounts?.slice(
    0,
    MAX_AMOUNT_OF_LABELS,
  );

  return general_mapDiscountsToLabels(discounts).length > 0;
});

watch(
  toggleIsChecked,
  (isChecked) => {
    familyStore.inputs.bindingPeriodRadioValue = isChecked ? '12' : '0';
  },
  { immediate: true },
);

watch(
  () => familyStore.inputs.bindingPeriodRadioValue,
  (value) => {
    toggleIsChecked.value = value === '12';
  },
);
</script>
